import { UIIcon } from '../../config/icons';
import { uiToast } from '../ui/component/toast';
import { $el } from '../ui/elements';
import { UIView, UIViewAddSpec, UIViewSpec } from '../ui/view';
import { $clip, YClipObject } from '../y/clip';
import { YInput, YForm, $form } from '../y/form';
import { EDBlockContainer, EDButtonSpec, EDEditor, EDObject } from './editor';

export interface EDNewBlock<Block extends { type: string }> {
    name: string;
    icon: UIIcon;
    block: Block;
    experimental?: boolean;
}

export interface EDBlockSpec<Block extends { type: string }, Extra extends {} = {}> {
    key: Block['type'];
    editor_block: new (container: EDBlockContainer<Extra>, type: Block['type']) => EDBlock<Extra>;
}

export abstract class EDBlock<Extra extends {} = {}> extends UIView implements EDObject {
    form: YInput<any>;
    properties: UIViewSpec;
    parent: EDBlockContainer<Extra>;
    editor: EDEditor<any, any, Extra> & Extra;
    private _name: string;

    constructor(form: YForm | undefined, parent: EDBlockContainer<Extra>, name: string, properties: UIViewSpec = $el.DIV(), element?: HTMLElement) {
        if(element) {
            super(element);
            this.classList.add('ed-block', 'ed-object');
        } else {
            super('div', 'ed-block ed-object');
        }

        this.ui_elem.ed_object = this;

        this.parent = parent;
        this.editor = parent.editor;
        this._name = name;

        this.root.addEventListener('click', e => {
            this.editor.selectObject(this);
            e.stopPropagation();
        });

        if(form) {
            form.add('type', $form.noop());
            this.form = form;
        } else {
            this.form = $form.noop();
        }
        this.properties = properties;
    }

    getButtons(): EDButtonSpec[] {
        return this.parent.getChildButtons(this);
    }

    makeForm(): UIViewAddSpec {
        return this.properties;
    }

    doCopy(): void {
        $clip.writeObject('ed-block', this.form.value).then(() => { uiToast('Block copied to clipboard') });
    }

    doPaste(object: YClipObject): void {
        this.parent.doPaste(object, this);
    }

    doRemove(): void {
        this.parent.removeBlock?.(this);
    }

    get name() {
        return this._name;
    }

    set name(n: string) {
        this._name = n;
        this.editor.tree.update(this);
    }
}
